import React from 'react';
import Box from '@mui/material/Box';
import visuallyHidden from '@mui/utils/visuallyHidden';

export const TypingDots: React.FC = () => (
    <>
        <div className="typing-dot" />
        <div className="typing-dot" />
        <div className="typing-dot" />
        <Box component="span" role="status" aria-live="polite" sx={visuallyHidden}>
            Generating response…
        </Box>
    </>
);
